import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { provideTranslocoScope, TranslocoModule } from '@jsverse/transloco';
import { StaticImageUrlPipe } from '@rma/generic/util/pipes/static-image-url';
import { StripNewLinePipeModule } from '@rma/generic/util/translation';

export interface OnboardingCompletedModalData {
  shortName: string;
}
@Component({
  selector: 'rma-onboarding-completed-modal',
  imports: [StaticImageUrlPipe, MatDialogModule, MatButtonModule, TranslocoModule, StripNewLinePipeModule],
  templateUrl: './completed-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideTranslocoScope('onboardingList')],
})
export class OnboardingCompletedModalComponent {
  protected readonly scope = 'onboardingList.completedModal';
  protected readonly shortName: string;

  public constructor(@Inject(MAT_DIALOG_DATA) data: OnboardingCompletedModalData) {
    this.shortName = data.shortName;
  }
}
